import request from '@/utils/request'

// 查询意见反馈列表
export function listAppFeedback(query) {
  return request({
    url: '/app/app/feedback/list',
    method: 'get',
    params: query
  })
}

// 查询意见反馈详细
export function getAppFeedback(id) {
  return request({
    url: '/app/app/feedback/' + id,
    method: 'get'
  })
}

// 新增意见反馈
export function addAppFeedback(data) {
  return request({
    url: '/app/app/feedback',
    method: 'post',
    data: data
  })
}

// 修改意见反馈
export function updateAppFeedback(data) {
  return request({
    url: '/app/app/feedback',
    method: 'put',
    data: data
  })
}

// 删除意见反馈
export function delAppFeedback(id) {
  return request({
    url: '/app/app/feedback/' + id,
    method: 'delete'
  })
}
